import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Project } from '@/types/projects'

export async function getProjectById(id: number, options?: AxiosRequestConfig) {
  const { data } = await companiesApi.get<Project>(
    apiRoutes.getProjectById(id),
    options,
  )
  return data
}
